import classNames from 'classnames';

import style from './TaskStatusBadge.module.scss';

import { FrontendTaskStatus, TaskStatus } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';
import { DateHelper } from '@utils/DateHelper';
import { translate } from '@chaika/i18n/helper';

interface Props {
    status: TaskStatus | FrontendTaskStatus;
    end?: Date;
    className?: string;
}

export function TaskStatusBadge({ status, end, className }: Props): React.ReactElement<any> | null {
    const isExpired = isDefined(end) ? DateHelper.isBefore(end, new Date()) : false;

    const classnames = classNames([
        style.badge,
        status === TaskStatus.Completed && style.badge_completed,
        status === TaskStatus.Cancelled && style.badge_rejected,
        isExpired && style.badge_expired,
        className,
    ]);

    let content = null;

    switch (status) {
        case TaskStatus.Cancelled:
            content = <div className={classnames}>{translate('canceled')}</div>;
            break;
        case TaskStatus.Completed:
            content = <div className={classnames}>{translate('taskCompleted')}</div>;
            break;
    }

    if (isExpired) {
        content = <div className={classnames}>{translate('overdue')}</div>;
    }

    return content;
}
